import { useFormat } from '@ideavivat/vivat-2';
import { target_date } from './base';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    description: {
      name: 'ชิ้นส่วน',
      width: '1fr',
    },
    amount: {
      name: 'จำนวนที่สั่ง / รับแล้ว',
      width: '8rem',
      class: 'text-center',
      filter: (val: string, row: any) => `${parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} / ${parseFloat(row.item.filled_amount || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`,
    },
    unit: {
      name: 'หน่วย',
      width: '5rem',
    },
    price_per_unit: {
      name: 'ราคา/หน่วย',
      width: '6rem',
      class: 'text-right',
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    total_price: {
      name: 'ราคารวม',
      width: '6rem',
      class: 'text-right',
      filter: (val: any, row: any) => parseFloat((val || 0) * (row.item.amount_per_unit || 0) as any).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    target_date,
  },
};
